import styled from "styled-components";

export const FieldsDiv = styled.div`
  /* background-color: #fff; */
  padding: 1.5rem;
  border-radius: 10px;
  width: 100%;

  display: ${(props) => (props.show ? "flex" : "none")};
  justify-content: center;
  flex-direction: column;

  h1 {
    text-align: center;
    margin-bottom: 2rem;
  }

  .buttons {
    margin: 1rem 0;

    button {
      padding: 0.3rem;
      margin-right: 1rem;
    }
  }

  .fields {
    /* width: 53rem; */
    width: max-content;
    display: flex;
    /* justify-content: center;  */
    flex-wrap: wrap;
    gap: 3rem;
  }
`;

export const ButtonField = styled.div`
  &,
  input {
    width: 250px;
    height: 40px;
    position: relative;
    /* font-weight: bold; */
    color: hsl(0, 0%, 50%);
    font-size: 15px;

    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .icon {
    position: absolute;
    height: 1.8rem;
    width: 1.8rem;
    padding: 4px;
    top: 50%;
    right: 2px;
    transform: translateY(-50%);

    color: #555;
  }

  input {
    padding: 0 10px;

    background-color: transparent;
    border-color: rgba(0, 0, 0, 0.23);
    border-radius: 4px;
    border-style: solid;
    border-width: 1px;
  }
`;
